/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timing_SettingsInputs */



/**
* | output |
* | --- |
* | "Timing Settings" |
*
* @param {Timing_SettingsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timing_settings = /** @type {((inputs?: Timing_SettingsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timing_SettingsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres de minutage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeiteinstellungen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impostazioni di temporizzazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Настройки времени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustes de tiempo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("计时设置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイミング設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय सेटिंग्स")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Configurações de tempo")
	return /** @type {LocalizedString} */ ("Timing Settings")
});